import type { Mission } from "@/features/missionkit/api/use-mission";
export const HANDLER_MISSION_API = "/api/secretmissions/companion/mission/";
export type GraduationIntake = {
  time: "ten" | "hour" | "five" | "day";
  place: "home" | "work" | "out" | "friends" | "other" | "unsure";
  person:
    | "partner"
    | "family"
    | "friend"
    | "work"
    | "neighbor"
    | "stranger"
    | "other"
    | "unsure";
  name?: string;
  idea?: string;
  needHelp?: boolean;
};
export type HandlerMissionFlow = {
  id: string;
  phase:
    | "review"
    | "accepted"
    | "filed"
    | "discover"
    | "craft"
    | "active"
    | "report";
  acceptedAt?: string;
  enemyReady?: boolean;
  mission: Mission;
  number?: number;
  grad?: GraduationIntake;
  starting?: Record<string, string>;
  Clues?: Record<string, string>;
  needHelp?: boolean;
};
